// Small formatting helpers shared by the admin Visitor Statistics tabs.

export const toDate = (value) => {
  if (!value) return null;
  const date = typeof value.toDate === 'function' ? value.toDate() : value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateTime = (value) => {
  const date = toDate(value);
  return date
    ? date.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '—';
};

export const formatTime = (value) => {
  const date = toDate(value);
  return date ? date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—';
};

export const formatDay = (value) => {
  const date = toDate(value);
  return date ? date.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }) : '—';
};

/** "5 min ago", "3 h ago", "2 d ago"; falls back to the date for anything older than 30 days. */
export const timeAgo = (value) => {
  const date = toDate(value);
  if (!date) return '—';
  const seconds = Math.max(0, Math.round((Date.now() - date.getTime()) / 1000));
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} h ago`;
  if (seconds < 30 * 86400) return `${Math.floor(seconds / 86400)} d ago`;
  return formatDateTime(date);
};

export const formatDuration = (from, to) => {
  const a = toDate(from);
  const b = toDate(to);
  if (!a || !b) return '';
  const minutes = Math.round((b - a) / 60000);
  if (minutes < 1) return '< 1 min';
  if (minutes < 60) return `${minutes} min`;
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
};

export const initialsOf = (name, email) => {
  const source = (name && name !== 'No name' ? name : email || '?').trim();
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  return ((parts[0]?.[0] || '?') + (parts.length > 1 ? parts[1][0] : '')).toUpperCase();
};

// Stable avatar colour per user. All are dark enough for white text (>= 4.5:1).
const AVATAR_COLOURS = ['#4338ca', '#0f766e', '#a21caf', '#be123c', '#1d4ed8', '#b45309', '#047857', '#6d28d9'];
export const avatarColour = (key = '') => {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return AVATAR_COLOURS[hash % AVATAR_COLOURS.length];
};

export const plural = (n, word) => `${n.toLocaleString()} ${word}${n === 1 ? '' : 's'}`;

/** Friendly text for a Firestore read error, with the likely fix for the usual one. */
export const describeLoadError = (error, collectionName) => {
  if (error?.code === 'permission-denied') {
    return `Firestore blocked reading "${collectionName}". Publish the "${collectionName}" rules (see firestore.rules.merged-preview.txt), then press Retry.`;
  }
  return error?.message || `Could not load ${collectionName}.`;
};
